import React from 'react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        {/* HoppHomes Logo Area */}
        <div className="mb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
            <span className="text-[#e31937]">Hopp</span>Homes
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-[#e31937] to-[#b91c1c] mx-auto rounded-full"></div>
        </div>

        {/* Maintenance Icon */}
        <div className="text-8xl md:text-9xl mb-8 animate-pulse">
          🔧
        </div>

        {/* Main Message */}
        <div className="bg-gradient-to-br from-[#e31937] to-[#b91c1c] rounded-2xl p-8 md:p-12 shadow-2xl border border-[#e31937]/30">
          <h2 className="text-white text-3xl md:text-4xl font-bold mb-6">
            KARBANTARTÁS ALATT
          </h2>
          
          <div className="space-y-4 text-white/90 text-lg md:text-xl leading-relaxed">
            <p>
              Jelenleg karbantartást és további fejlesztéseket végzünk az oldalon.
            </p>
            <p className="font-semibold text-xl md:text-2xl text-yellow-300">
              Hamarosan újra jövünk!
            </p>
          </div>

          {/* Additional Info */}
          <div className="mt-8 pt-6 border-t border-white/[0.08]">
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-white/70">
              <div className="flex items-center gap-2">
                <span className="text-xl">🏠</span>
                <span className="text-sm">Mobilház értékesítés</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xl">🔄</span>
                <span className="text-sm">Rendszer frissítés</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xl">⚡</span>
                <span className="text-sm">Teljesítmény optimalizálás</span>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="mt-8 pt-6 border-t border-white/[0.08]">
            <p className="text-white/70 text-sm">
              Sürgős esetben írjon nekünk: 
              <a href="mailto:hoppxplatform@gmail.com" className="text-yellow-300 hover:text-yellow-200 ml-1 underline">
                hoppxplatform@gmail.com
              </a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-white/50 text-sm">
          <p>Köszönjük a türelmét! 🙏</p>
          <p className="mt-2">© 2025 HoppHomes - Minden jog fenntartva</p>
        </div>

        {/* Animated Background Elements */}
        <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#e31937]/5 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#e31937]/3 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-3/4 left-1/2 w-48 h-48 bg-[#e31937]/4 rounded-full blur-3xl animate-pulse delay-500"></div>
        </div>
      </div>
    </div>
  );
}
